"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var stylesImport = require("./Label.scss");
var styles = stylesImport;
var Label = (function (_super) {
    tslib_1.__extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, required = _a.required, children = _a.children, className = _a.className;
        return (React.createElement("label", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties), { className: Utilities_1.css(styles.root, 'ms-Label', className, disabled && ('is-disabled ' + styles.isDisabled), required && ('is-required ' + styles.isRequired)) }), children));
    };
    return Label;
}(Utilities_1.BaseComponent));
exports.Label = Label;
//# sourceMappingURL=Label.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Label/Label.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Label/Label.js
// module chunks = 1